<script>

    import { toast } from 'bulma-toast'
    import { modalStore } from '../stores'

    import LocationsService from '../$services/locations.service'
    import Spinner from '../$components/spinner.svelte'

    export let data = {}

    let loading = false

    async function createLocation() {

        loading = true
        const resp = await LocationsService.createLocation(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
        
        toast({message: 'Dirección creada', type: 'is-success'})
        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={createLocation}>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Alias</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-address-book"></i></span>
                        <input bind:value={data.alias} type="text" class="input" placeholder="Identificador de la dirección" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <table class="table is-fullwidth">
                    <tbody>
                        <tr>
                            <th>Contacto</th>
                            <td>{ data.contact || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>RFC</th>
                            <td>{ data.rfc || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Corporación</th>
                            <td>{ data.corporate || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Teléfono</th>
                            <td>{ data.phone || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Correo</th>
                            <td>{ data.email || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Código postal</th>
                            <td>{ data.zipcode || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Estado</th>
                            <td>{ data.state || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Ciudad</th>
                            <td>{ data.city || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Municipio</th>
                            <td>{ data.municipality || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Colonia</th>
                            <td>{ data.colony || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Calle</th>
                            <td>{ data.street || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Exterior</th>
                            <td>{ data.number || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Interior</th>
                            <td>{ data.aparment || 'Sin información' }</td>
                        </tr>
                        <tr>
                            <th>Referencias</th>
                            <td>{ data.references || 'Sin información' }</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="items-end">
            <button on:click={() => modalStore.close() } type="button" class="button space-right">
                <span class="icon"><i class="fas fa-ban"></i></span>
                <span>Cancelar</span>
            </button>
            <button type="submit" class="button is-primary">
                <span class="icon"><i class="fas fa-save"></i></span>
                <span>Guardar</span>
            </button>
        </div>
    </form>
{/if}